module.exports = __webpack_public_path__ + "static/media/caret-circle-down.f414bb25.svg";